import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Container, Col, Row } from 'react-grid-system';
import { BackLabel, BackLink, RightWrapper } from './styles';
import IconFont from '../../../components/shared/IconFont';
import FavouritesToggle from '../../HubLive/FilterBar/FavouritesToggle';
import ConfigManager from '../../../common/configManager/configManager';
import Divisor from '../../../components/shared/Divisor';
import RefreshButton from './RefreshButton';

export class FavouritesBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  render() {
    const {
      actions,
      favouritesCounter,
      location,
      isMobile,
    } = this.props;
    return (
      <Container
        fluid
        style={{
          marginTop: isMobile ? '1em' : '0em',
          marginBottom: isMobile ? '0.5em' : '1.8em',
          paddingBottom: isMobile ? '12px' : 'none',
          paddingLeft: 0,
          paddingRight: 0,
        }}
      >
        <Divisor
          width="104.8%"
          height="1px"
          color="mediumDarkGray"
          top="60px"
          left="-10px"
        />
        <Row style={{ alignItems: 'center', marginLeft: isMobile ? '8px' : '0px', marginRight: isMobile ? '12px' : '0px' }}>
          <Col
            md={2}
            sm={2}
            xs={2}
            style={{
            paddingLeft: 0, paddingRight: 0, textAlign: 'left', alignSelf: 'flex-start',
          }}
          >
            <BackLink to={ConfigManager.getRoute('hublive', process.env.REACT_APP_SITE)}>
              <IconFont
                className="icon-matchcenter-back-arrow"
                color="black"
                font={22}
                weight="bold"
                withCursor
              />
            </BackLink>
          </Col>
          <Col
            md={8}
            sm={8}
            xs={8}
            style={{
              paddingLeft: 0, paddingRight: 0, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
            }}
          >
            <BackLabel>
              I tuoi eventi
            </BackLabel>
            <RefreshButton marginLeft={0.3} />
          </Col>
          <Col md={2} sm={2} xs={2} style={{ paddingLeft: 0, paddingRight: 0, alignSelf: 'flex-start' }}>
            <RightWrapper>
              <FavouritesToggle
                favouritesCounter={favouritesCounter}
                actions={actions}
                location={location}
                isFavourite
              />
            </RightWrapper>
          </Col>
        </Row>
      </Container>
    );
  }
}

FavouritesBar.propTypes = {
  actions: PropTypes.any,
  favouritesCounter: PropTypes.number,
  location: PropTypes.any,
  isMobile: PropTypes.bool,
};

export default FavouritesBar;
